import { Column } from 'react-table'
import GetUrls from 'ts/enums/Url'
import { Department } from 'ts/types/Department'
import { Boolean as BooleanCell } from 'components/ui'
import CardTable from 'components/CardTable'
import DepartmentAddPage from './DepartmentAddPage'

const columns: Column<Department>[] = [
  {
    Header: 'ID',
    accessor: 'departmentId'
  },
  {
    Header: 'Active',
    accessor: 'isActive',
    Cell: ({ value }) => <BooleanCell value={value} />
  },
  {
    Header: 'Department',
    accessor: 'departmentName'
  }
]

const ProductCategoryPage = () => {
  const Url = GetUrls();
  return (
  <CardTable
    columns={columns}
    dataKey={Url.getDepartment.toString()}
    url={Url.getDepartment}
    listName={"departmentList"}
    modalChild={<DepartmentAddPage />}
  />
)}

export default ProductCategoryPage
